import { render } from "./WasteContainer.vue?vue&type=template&id=c5f8bf06&scoped=true"
import script from "./WasteContainer.vue?vue&type=script&lang=js"
export * from "./WasteContainer.vue?vue&type=script&lang=js"

import "./WasteContainer.vue?vue&type=style&index=0&id=c5f8bf06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f8bf06"]])

export default __exports__